import axios from "axios"
import dayjs, {Dayjs} from "dayjs";
import {SiteInfo} from "../interfaces/site-info"

declare const siteInfo: SiteInfo;

export interface Price {
    id: string;
    start_date: string;
    nights: number;
    rate: number;
    discount: number;
}

export interface PriceResponseData {
    prices: Price[];
    not_booked: string[];
}

export interface PriceResponse {
    success: boolean;
    data: PriceResponseData;
}

export interface DateAvailability {
    id: string;
    dateTime: string;
    arrival: boolean;
    booked: boolean;
}

export interface AvailabilityData {
    dates: DateAvailability[];
}

export interface EndDate {
    dateTime: string;
}

export interface EndDateResponse {
    dates: EndDate[];
    noPriceMessage: string;
    allowEnquiries: boolean
}


export const getPriceData = async (id: string, start: Dayjs, end: Dayjs, sleeps?: string): Promise<PriceResponseData> => {
    if (!siteInfo.url)
        throw new Error('Site url not set');

    const { data } = await axios.get(
        siteInfo.url + '/wp-json/accommodation/property/availability',
        {
            params: {
                id,
                start: start.format('YYYY-MM-DD'),
                end: end.format('YYYY-MM-DD'),
                sleeps
            }
        }
    );
    if (!data.success)
        throw new Error('Response was not successful');

    return data.data;
}


export const getStartDates = async (id: string, start: Dayjs, end: Dayjs, key?: string): Promise<AvailabilityData> => {

    const { data } = await axios.get(
        'https://api.supercontrol.co.uk/v3/Calendar/GetDates',
        {
            params: {
                cottageIDS: id,
                startdate: start.format('YYYY-MM-DD'),
                enddate: end.format('YYYY-MM-DD'),
                key:key
            }
        }
    );
    return data.dates[id];
}

export const getEndDates = async (id: string, start: Dayjs, key?: string): Promise<EndDateResponse> => {
    const { data } = await axios.get(
        'https://api.supercontrol.co.uk/v3/Calendar/GetEndDates',
        {
            params: {
                cottageID: id,
                startdate: start.format('YYYY-MM-DD'),
                key:key
            }
        }
    );
    return data;
}